import { gsap } from 'gsap';

export default {
	name: 'default',
	before({ current, next, trigger }) {
		document.body.classList.add('body--transitioning');

		return new Promise((resolve) => {
			const headerBar = current.container.querySelector('.c-header-bar');

			const headerBarPromise = new Promise((resolve) => {
				if (document.body.classList.contains('has-menu-sticky') && document.body.classList.contains('has-story-overview-openend')) {
					document.body.classList.remove('has-scrolled', 'has-menu-sticky');
					headerBar.addEventListener('transitionend', () => resolve(), { once: true });
				} else {
					resolve();
				}
			});

			// Eerst de header bar laten animeren, dan een fade out
			headerBarPromise.then(() => {
				gsap.to(current.container, {
					opacity: 0,
					ease: 'none',
					duration: 0.5,
					delay: 0,
					onComplete: () => {
						resolve();
					},
				});
			});
		});
	},
	beforeLeave({ current, next, trigger }) {
		if (document.body.classList.contains('has-menu-sticky')) {
			document.body.classList.remove('has-scrolled', 'has-menu-sticky');
		}
	},
	afterLeave({ current, next, trigger }) {
		gsap.set(current.container, {
			position: 'absolute',
			top: 0,
			left: 0,
			width: '100%',
		});

		gsap.set(next.container, {
			opacity: 0,
		});
	},
	enter({ current, next, trigger }) {
		return new Promise((resolve) => {
			gsap.to(next.container, {
				opacity: 1,
				ease: 'none',
				duration: 0.8,
				delay: 0,
				onComplete: () => {
					resolve();
				},
			});
		});
	},
	after({ current, next, trigger }) {
		document.body.classList.remove('body--transitioning');
	},
};
